import React, { createContext, useContext, useState } from 'react';

const routeContext = createContext({});

const RouteProvider = ({ children, routeData }) => {
  const [currentRouteData, setCurrentRouteData] = useState(routeData);

  const saveRouteData = (values) => {
    setCurrentRouteData(values);
  };

  return (
    <routeContext.Provider value={{ routeData: currentRouteData, saveRouteData }}>{children}</routeContext.Provider>
  );
};

type RouteContext = {
  routeData?: any;
  saveRouteData?: any;
};

const useRoute = () => {
  return useContext<RouteContext>(routeContext);
};

export { useRoute };
export default RouteProvider;
